import * as z$1 from "zod/v4";
//#region src/schemas/daemon/runtime-reporting-health.ts
const RUNTIME_REPORTING_HEALTH_SCHEMA_VERSION = 1;
const RUNTIME_REPORTING_HEALTH_SCHEMA_NAME = "openmeld-runtime-reporting-health-v1";
const RUNTIME_REPORTING_FAILURE_REASON_CODE_MAX_LENGTH = 160;
const RUNTIME_REPORTING_FAILURE_MESSAGE_MAX_LENGTH = 500;
const RUNTIME_REPORTING_CHANNELS = ["runtimeAgentController", "providerConversationProof"];
const runtimeReportingChannelSchema = z$1.enum(RUNTIME_REPORTING_CHANNELS);
const runtimeReportingHealthFailureSchema = z$1.strictObject({
	at: z$1.iso.datetime({ offset: true }),
	reasonCode: z$1.string().min(1).max(160),
	message: z$1.string().min(1).max(500)
});
const runtimeReportingApplicabilitySchema = z$1.strictObject({
	status: z$1.enum(["applicable", "not_applicable"]),
	observedAt: z$1.iso.datetime({ offset: true })
});
const runtimeReportingServiceIdentitySchema = z$1.strictObject({
	deviceId: z$1.string().trim().min(1),
	contractGeneration: z$1.int().nonnegative()
});
const runtimeReportingChannelHealthSchema = z$1.strictObject({
	applicability: runtimeReportingApplicabilitySchema.optional(),
	lastSuccessAt: z$1.iso.datetime({ offset: true }).nullable(),
	consecutiveFailures: z$1.int().nonnegative(),
	lastFailure: runtimeReportingHealthFailureSchema.nullable()
});
const runtimeReportingHealthStateSchema = z$1.strictObject({
	schema: z$1.literal(RUNTIME_REPORTING_HEALTH_SCHEMA_NAME),
	v: z$1.literal(1),
	serviceIdentity: runtimeReportingServiceIdentitySchema.optional(),
	serviceIdentityObservedAt: z$1.iso.datetime({ offset: true }).optional(),
	runtimeAgentController: runtimeReportingChannelHealthSchema,
	providerConversationProof: runtimeReportingChannelHealthSchema
});
//#endregion
export { RUNTIME_REPORTING_CHANNELS, RUNTIME_REPORTING_FAILURE_MESSAGE_MAX_LENGTH, RUNTIME_REPORTING_FAILURE_REASON_CODE_MAX_LENGTH, RUNTIME_REPORTING_HEALTH_SCHEMA_NAME, RUNTIME_REPORTING_HEALTH_SCHEMA_VERSION, runtimeReportingApplicabilitySchema, runtimeReportingChannelHealthSchema, runtimeReportingChannelSchema, runtimeReportingHealthFailureSchema, runtimeReportingHealthStateSchema, runtimeReportingServiceIdentitySchema };

//# sourceMappingURL=runtime-reporting-health.js.map